import { render, staticRenderFns } from "./work-order-draft-list.vue?vue&type=template&id=47c4c6e5"
import script from "./work-order-draft-list.vue?vue&type=script&lang=js"
export * from "./work-order-draft-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports